<template>
	<span
		class="g-pay-icon"
		:class="[`g-pay-icon--${icon}`, { 'g-pay-icon--h5': h5 }]"
		:style="iconStyle"
		aria-hidden="true"
	>
		<i :style="iconStyle" v-if="icon === 'trial'" class="mbm-iconfont mbm-bofang3"></i>
		<i :style="iconStyle" v-else-if="icon === 'limited'" class="mbm-iconfont mbm-shipinkecheng"></i>
		<i :style="iconStyle" v-else-if="icon === 'pack'" class="mbm-iconfont mbm-ziliaoku"></i>
		<i :style="iconStyle" v-else-if="icon === 'community'" class="mbm-iconfont mbm-shequn"></i>
		<i :style="iconStyle" v-else-if="icon === 'image'" class="mbm-iconfont mbm-gongxiangtuku"></i>
		<i :style="iconStyle" v-else-if="icon === 'overseas'" class="mbm-iconfont mbm-AI2"></i>
		<i :style="iconStyle" v-else-if="icon === 'creator'" class="mbm-iconfont mbm-zuopinchuangzuo"></i>
		<i :style="iconStyle" v-else-if="icon === 'mystery'" class="mbm-iconfont mbm-unlock"></i>
	</span>
</template>

<script>
	export default {
		name: 'GPayIcon',
		props: {
			icon: {
				type: String,
				required: true,
			},
			color: {
				type: String,
				default: '#fff',
			},
			bg: {
				type: String,
				default: '#ff4b2b',
			},
			h5: {
				type: Boolean,
				default: false,
			},
		},
		computed: {
			iconStyle() {
				return {
					color: this.bg,
				};
			},
		},
	};
</script>

<style scoped lang="less">
	.g-pay-icon {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		width: 34px;
		height: 34px;
		border-radius: 50%;
		flex-shrink: 0;
		margin-right: 4px;
		i {
			font-size: 34px;
			line-height: 1;
		}

		

		&--h5 {
			width: 0.68rem;
			height: 0.68rem;
			margin-right: 0.08rem;

			i {
				font-size: 0.68rem;
			}

		}
	}
</style>
